import React from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useHistory } from "react-router-dom";
import { Button, Spinner } from "reactstrap";
import { requestRFQAccess } from "../services/QuoteServices";
import { toast } from "react-toastify";
import { useState } from "react";
import { isLoggedIn } from "../utils";

/**
 * Props:
 *  - open: boolean
 *  - onClose: () => void
 *  - variant: "notLoggedIn" | "noPermission"
 */
export default function RFQModal({ open, onClose, variant }) {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  const handleSignIn = () => {
    onClose();
    history.push(
      `/login?redirect=${encodeURIComponent(history.location.pathname)}`,
    );
  };

  const handleRequestAccess = () => {
    setIsLoading(true);
    requestRFQAccess()
      .then((res) => {
        console.log("res", res);
        toast.success(res.message);
      })
      .catch((err) => {
        console.error("err", err);
        toast.error("Failed to request access");
      })
      .finally(() => {
        setIsLoading(false);
        onClose();
      });
  };

  return (
    <Modal open={!!open} onClose={onClose} center focusTrapped>
      <div style={{ padding: 16, maxWidth: 520 }}>
        {variant === "notLoggedIn" && (
          <>
            <h4>You must be signed in</h4>
            <p>
              Please sign in and request permission to access RFQ (Request for
              Quote) features.
            </p>
            <Button className="get-quote-button" onClick={handleSignIn}>
              Sign in
            </Button>
          </>
        )}

        {variant === "noPermission" && (
          <>
            <h3 className="rfq-access-header">Access required</h3>
            <p className="request-access-content">
              Access to RFQs (Request for Quotation) is dedicated to
              large-volume or custom orders. For pricing and details, please
              contact our customer support directly at:&nbsp;
              <a
                href="mailto:support@buygroup.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                support@buygroup.com
              </a>
              &nbsp; or 469-261-8179
            </p>
            <p className="request-access-content">
              Let's make sure your needs are met.
            </p>
            {/* {isLoggedIn() && (
              <Button
                className="get-quote-button"
                onClick={handleRequestAccess}
                disabled={isLoading}
              >
                {isLoading ? <Spinner size="sm" /> : "Request Access"}
              </Button>
            )} */}
          </>
        )}
      </div>
    </Modal>
  );
}
